import React, { useState } from 'react'
import ButtonCircle from '../../../../shared/components/button_circle';
import '../styles.scss'
import { ReportInterface } from '../../../../stateManagement/redux/slices/gerencia_tecnica/interfaces';
import ButtonBig from '../../../../shared/components/button_big';
import { sharedReport } from '../../../../stateManagement/redux/slices/gerencia_tecnica/asyncReducers';
import { useDispatch } from "../../../../stateManagement/redux"

export const SharedModal = ({ onClose, report, filters }: { onClose: any, report: ReportInterface, filters: any }) => {

  const dispatch = useDispatch();

  const [email, setEmail] = useState<string[]>([])

  const [shareByEmail, setShareByEmail] = useState(false)

  const [download, setDownload] = useState(false)

  const sendEmail = () => {
    dispatch(sharedReport(report.id, report.code, filters.startDate, filters.endDate, filters.projectId, email, shareByEmail, download))
    onClose()
  }

  const onChangeEmail = (e: any) => {
    const emails = e.target.value.split(',')
    setEmail(emails)
  }

  const onChangeSelect = (e: any) => {
    if (e === 'email') {
      setShareByEmail(!shareByEmail)
    }

    if (e === 'download') {
      setDownload(!download)
    }
  }

  return (
    <>
      <div className='report_complementary_black_container' />
      <div className='report_complementary_modal'>
        <div className='report_viewer_header'>
          <div>
            Modulo de Compartir Reporte
          </div>
          <div>
            <ButtonCircle icon="/assets/icons/close.svg" iconHeight={15} iconWidth={15} onClick={onClose} />
          </div>
        </div>
        <div className='shared_module_container'>
          <div className='content_container'>
            <div>Seleccionas las opciones para compartir el reporte {report.name} :</div>
            {/* correo */}
            <div>
              <div>
                <input type="checkbox" id="shareEmail" name="shareOption" value="email" onChange={(e) => onChangeSelect(e.target.value)} />
                <label htmlFor="shareEmail">Enviar por Correo</label>
              </div>
              {shareByEmail && (
                <input type="text" placeholder='Email' className='input_container_email' value={email.join(',')} onChange={(e) => onChangeEmail(e)} />
              )}
            </div>

            {/* download */}
            <div>
              <input type="checkbox" id="download" name="shareOption" value="download" onChange={(e) => onChangeSelect(e.target.value)} />
              <label htmlFor="download">Descargar Archivo</label>
            </div>
          </div>
          {/* button */}
          <ButtonBig icon="/assets/icons/share.svg" text='Procesar' iconHeight={30} onClick={sendEmail} />
        </div>
      </div>
    </>
  )
}